import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface EmailStore {
  email: string;
  setEmail: (email: string) => void;
  clearEmail: () => void;
}

export const useEmailStore = create<EmailStore>()(
  persist(
    (set) => ({
      email: "",
      setEmail: (email: string) => set({ email }),
      clearEmail: () => set({ email: "" }),
    }),
    {
      name: "email-storage",
      storage: createJSONStorage(() => localStorage), // Muda para sessionStorage se precisar que os dados sejam apagados ao fechar o navegador
      partialize: (state) => ({ email: state.email }), // Armazena apenas o email
    }
  )
);
